import clsx from 'clsx';
import { Base } from '../Base';
import { SrOnly } from '../Helper/SrOnly/SrOnly';
import Svg from '../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Products-root_1mjWC",
  "icon": "Products-icon_2qWzn",
  "pulse": "Products-pulse_1Sm2b",
  "default": "Products-default_1RifK",
  "small": "Products-small_1j9FU"
};
const Icon = props => /*#__PURE__*/_jsx(Svg, {
  className: styles.icon,
  ...props
});
function Products({
  variant = 'default',
  theme = 'light',
  title,
  className,
  ...extraProps
}) {
  const rootClasses = clsx(styles.root, styles[variant], className);
  const svgTheme = theme === 'dark' ? 'white' : 'brand';
  return /*#__PURE__*/_jsxs(Base, {
    className: rootClasses,
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Icon, {
      name: "domainOutline",
      theme: svgTheme
    }), /*#__PURE__*/_jsx(Icon, {
      name: "dnsOutline",
      theme: svgTheme
    }), /*#__PURE__*/_jsx(Icon, {
      name: "certificatesOutline",
      theme: svgTheme
    }), /*#__PURE__*/_jsx(Icon, {
      name: "simplehostingOutline",
      theme: svgTheme
    }), /*#__PURE__*/_jsx(Icon, {
      name: "cloudOutline",
      theme: svgTheme
    }), /*#__PURE__*/_jsx(SrOnly, {
      children: title
    })]
  });
}
export default Products;